import Footer from './components/website/Footer.jsx';
import Header from './components/Header.jsx';
import Navigation from './components/Navigation';
import Dashboard from './views/Dashboard.jsx';
import ProductAnalysis from './views/ProductAnalysis.jsx';
import ProductAnalysisProductDetail from './views/ProductAnalysisProductDetail.jsx';
import ProductAnalysisProducts from './views/ProductAnalysisProducts.jsx';
import MetaAdsAnalytics from './views/MetaAdsAnalytics.jsx';
import KlaviyoAnalytics from './views/KlaviyoAnalytics.jsx';
import ProductBriefs from './views/ProductBriefs.jsx';
import AiAnalysis from './views/AiAnalysis.jsx';
import ProductRules from './views/ProductRules.jsx';
import OAuth from './views/OAuth.jsx';
import Contact from './views/website/Contact.jsx'
import Customers from './views/Customers.jsx';
import Customer from './views/Customer.jsx';
import Earnings from './views/Earnings.jsx';
import VIP from './views/VIP.jsx';
import Promotions from './views/promotions/Promotions.jsx';
import UpdatePromotion from './views/promotions/UpdatePromotion.jsx';
import PromotionReporting from './views/promotions/PromotionReporting.jsx';
import Giveaways from './views/giveaways/Giveaways.jsx';
import UpdateGiveaway from './views/giveaways/UpdateGiveaway.jsx';
import GiveawaysReporting from './views/giveaways/GiveawaysReporting.jsx';
import Tracking from './views/Tracking.jsx';
import Integrations from './views/Integrations.jsx';
import Settings from './views/Settings.jsx';
import SignUp from './views/website/SignUp.jsx';
import Login from './views/website/Login.jsx';
import Error from './views/Error.jsx';
import { ResponseDisplay } from './components/utility/Utility.jsx';
import { AuthContextProvider } from './contexts/AuthContext';
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import AuthorizedRoute from './components/AuthorizedRoute.jsx';
import UpdateIntegration from './views/UpdateIntegration.jsx';
import Home from './views/website/NewHome.jsx';
import UpdatePassword from './views/website/UpdatePassword.jsx';
import Earn from './views/website/Earn.jsx';
import WebGiveaways from './views/website/Giveaways.jsx';
import WebPromotions from './views/website/Promotions.jsx';
import PublicPricing from './views/website/Pricing.jsx';
import PrivacyPolicy from './views/website/policies/PrivacyPolicy.jsx';
import TermsConditions from './views/website/policies/TermsConditions.jsx';
import MobileTerms from './views/website/policies/MobileTerms.jsx';
import Redeem from './views/website/Redeem.jsx';
import WVIP from './views/website/WVIP.jsx';
import GettingStarted from './views/website/guides/GettingStarted.jsx';
import ShopifyOnboarding from './views/website/guides/ShopifyOnboarding.jsx';
import Onboarding from './views/Onboarding.jsx';
import Pricing from './views/Pricing.jsx';
import Support from './views/Support.jsx';
import ConfirmSignUp from './views/website/ConfirmSignUp';
import StoreOnboarding from './views/StoreOnboarding';
import InviteAccept from './views/InviteAccept';
import FreeStrategy from './views/website/landing/FreeStrategy.jsx';
import BlogIndex from './views/website/blog/BlogIndex.jsx';
import BlogPost from './views/website/blog/BlogPost.jsx';


export default function App() {
  const location = useLocation();
  const [id, setId] = useState('body');
  useEffect(() => {
    setId(location.pathname.includes('/app') ? "body" : "website")
  }, [location]);

  useEffect(() => {
    const crispScriptId = 'crisp-chat-script';
    const existingScript = document.getElementById(crispScriptId);

    const isWebsitePage = !location.pathname.includes('/app');
    const isAppSupportPage = location.pathname.includes('/app/support');
    const shouldShowChat = isWebsitePage || isAppSupportPage;

    if (shouldShowChat && !existingScript) {
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = "1137ed7d-01f9-492b-8348-87f41464bf7c";
      const script = document.createElement("script");
      script.id = crispScriptId;
      script.src = "https://client.crisp.chat/l.js";
      script.async = true;
      document.head.appendChild(script);
    } else if (!shouldShowChat && existingScript) {
      existingScript.remove();
      // Clean up Crisp's global variables and hide the widget if it's already been rendered
      if (window.$crisp) {
        window.$crisp.push(['do', 'chat:hide']);
      }
    }
  }, [location]);
  
  const hideNavigation = location.pathname === '/app/store-setup';
  
  return (
    <AuthContextProvider>
      <div className="App">
        <Header />
        <div id={id}>
          {!hideNavigation && <Navigation />}
          <Routes>
            <Route path="/auth/shopify" element={<OAuth />} />
            <Route path="/app" element={<Navigate to="/app/product-analysis/analytics" replace />} />
            <Route path="/app/support" element={<AuthorizedRoute><Support /></AuthorizedRoute>} />
            <Route path="/app/pricing" element={<AuthorizedRoute><Pricing /></AuthorizedRoute>} />
            <Route path="/app/onboarding" element={<AuthorizedRoute><Onboarding /></AuthorizedRoute>} />
            <Route path="/app/store-setup" element={<AuthorizedRoute><StoreOnboarding /></AuthorizedRoute>} />

            {/* Legacy redirects */}
            <Route path="/app/dashboard" element={<Navigate to="/app/loyalty/dashboard" replace />} />
            <Route path="/app/ai-analysis" element={<Navigate to="/app/product-analysis/ai" replace />} />
            <Route path="/app/program" element={<Navigate to="/app/loyalty/earn-redeem" replace />} />
            <Route path="/app/vip" element={<Navigate to="/app/loyalty/vip" replace />} />
            <Route path="/app/promotions" element={<Navigate to="/app/loyalty/promotions" replace />} />
            <Route path="/app/promotions/:id" element={<Navigate to="/app/loyalty/promotions/:id" replace />} />
            <Route path="/app/promotions/:id/amplifiers" element={<Navigate to="/app/loyalty/promotions/:id/amplifiers" replace />} />
            <Route path="/app/promotions/:id/review" element={<Navigate to="/app/loyalty/promotions/:id/review" replace />} />
            <Route path="/app/promotions/:id/reporting" element={<Navigate to="/app/loyalty/promotions/:id/reporting" replace />} />
            <Route path="/app/giveaways" element={<Navigate to="/app/loyalty/giveaways" replace />} />
            <Route path="/app/giveaways/:id" element={<Navigate to="/app/loyalty/giveaways/:id" replace />} />
            <Route path="/app/giveaways/:id/rewards" element={<Navigate to="/app/loyalty/giveaways/:id/rewards" replace />} />
            <Route path="/app/giveaways/:id/review" element={<Navigate to="/app/loyalty/giveaways/:id/review" replace />} />
            <Route path="/app/giveaways/:id/reporting" element={<Navigate to="/app/loyalty/giveaways/:id/reporting" replace />} />

            {/* Canonical Product Analysis routes */}
            <Route path="/app/product-analysis/briefs/*" element={<AuthorizedRoute><ProductBriefs /></AuthorizedRoute>} />
            <Route path="/app/product-analysis/analytics/meta-ads" element={<AuthorizedRoute><MetaAdsAnalytics /></AuthorizedRoute>} />
            <Route path="/app/product-analysis/analytics/klaviyo" element={<AuthorizedRoute><KlaviyoAnalytics /></AuthorizedRoute>} />
            <Route
              path="/app/product-analysis/analytics/product/:shopifyProductId"
              element={
                <AuthorizedRoute>
                  <ProductAnalysisProductDetail />
                </AuthorizedRoute>
              }
            />
            <Route path="/app/product-analysis/analytics" element={<AuthorizedRoute><ProductAnalysis /></AuthorizedRoute>} />
            <Route path="/app/product-analysis/products" element={<AuthorizedRoute><ProductAnalysisProducts /></AuthorizedRoute>} />
            <Route path="/app/product-analysis" element={<Navigate to="/app/product-analysis/analytics" replace />} />
            <Route path="/app/product-analysis/ai" element={<AuthorizedRoute><AiAnalysis /></AuthorizedRoute>} />
            <Route path="/app/product-analysis/rules" element={<AuthorizedRoute><ProductRules /></AuthorizedRoute>} />

            {/* Canonical Loyalty Program routes */}
            <Route path="/app/loyalty/dashboard" element={<AuthorizedRoute><Dashboard /></AuthorizedRoute>} />
            <Route path="/app/loyalty" element={<Navigate to="/app/loyalty/dashboard" replace />} />
            <Route path="/app/loyalty/earn-redeem" element={<AuthorizedRoute><Earnings /></AuthorizedRoute>} />
            <Route path="/app/loyalty/vip" element={<AuthorizedRoute><VIP /></AuthorizedRoute>} />
            <Route path="/app/loyalty/promotions" element={<AuthorizedRoute><Promotions /></AuthorizedRoute>} />
            <Route path="/app/loyalty/promotions/:id" element={<AuthorizedRoute><UpdatePromotion /></AuthorizedRoute>} />
            <Route path="/app/loyalty/promotions/:id/amplifiers" element={<AuthorizedRoute><UpdatePromotion /></AuthorizedRoute>} />
            <Route path="/app/loyalty/promotions/:id/review" element={<AuthorizedRoute><UpdatePromotion /></AuthorizedRoute>} />
            <Route path="/app/loyalty/promotions/:id/reporting" element={<AuthorizedRoute><PromotionReporting /></AuthorizedRoute>} />
            <Route path="/app/loyalty/giveaways" element={<AuthorizedRoute><Giveaways /></AuthorizedRoute>} />
            <Route path="/app/loyalty/giveaways/:id" element={<AuthorizedRoute><UpdateGiveaway /></AuthorizedRoute>} />
            <Route path="/app/loyalty/giveaways/:id/rewards" element={<AuthorizedRoute><UpdateGiveaway /></AuthorizedRoute>} />
            <Route path="/app/loyalty/giveaways/:id/review" element={<AuthorizedRoute><UpdateGiveaway /></AuthorizedRoute>} />
            <Route path="/app/loyalty/giveaways/:id/reporting" element={<AuthorizedRoute><GiveawaysReporting /></AuthorizedRoute>} />

            {/* Other app routes */}
            <Route path="/app/customers" element={<AuthorizedRoute><Customers /></AuthorizedRoute>} />
            <Route path="/app/customers/:id" element={<AuthorizedRoute><Customer /></AuthorizedRoute>} />
            <Route path="/app/integrations" element={<AuthorizedRoute><Integrations /></AuthorizedRoute>} />
            <Route path="/app/integrations/:id" element={<AuthorizedRoute><UpdateIntegration /></AuthorizedRoute>} />
            <Route path="/app/tracking" element={<AuthorizedRoute><Tracking /></AuthorizedRoute>} />
            <Route path="/app/settings" element={<AuthorizedRoute><Settings /></AuthorizedRoute>} />
            {/* Website routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reset-password" element={<UpdatePassword />} />
            <Route path="/confirm-signup" element={<ConfirmSignUp />} />
            <Route path="/invite" element={<InviteAccept />} />
            <Route path="/features/earn" element={<Earn />} />
            <Route path="/features/redeem" element={<Redeem />} />
            <Route path="/features/vip" element={<WVIP />} />
            <Route path="/features/giveaways" element={<WebGiveaways />} />
            <Route path="/features/promotions" element={<WebPromotions />} />
            <Route path="/pricing" element={<PublicPricing />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/mobile-terms" element={<MobileTerms />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            {/* Guides */}
            <Route path="/guides/getting-started" element={<GettingStarted />} />
            <Route path="/guides/shopify-onboarding" element={<ShopifyOnboarding />} />
            <Route path="/free-strategy-session" element={<FreeStrategy />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Error />} />
            {/* Duplicate this for /app/* */}
          </Routes>
          <script
          type="text/javascript"
          src="//static.klaviyo.com/onsite/js/klaviyo.js?company_id=V4YTdC"
          ></script>
        </div>
        <ResponseDisplay />
        <Footer />
      </div>

    </AuthContextProvider>
  )
  
}